import { render, staticRenderFns } from "./SwiperTwo.vue?vue&type=template&id=1d1bae49&scoped=true&"
import script from "./SwiperTwo.vue?vue&type=script&lang=js&"
export * from "./SwiperTwo.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTwo.vue?vue&type=style&index=0&id=1d1bae49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1bae49",
  null
  
)

export default component.exports